import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { ViewerRouter } from '@/components';
import { viewerRouteParamsSchema, viewerSearchParamsSchema } from '../-schemas';

export const Route = createFileRoute('/_layout/view/$areaSlug/$viewerType/$subjectSlug')({
  component: ViewerRouter,
  parseParams: (params) => viewerRouteParamsSchema.parse(params),
  validateSearch: zodSearchValidator(viewerSearchParamsSchema)
});
